import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../../_metronic/_partials/controls";
import { FormattedMessage, useIntl } from "react-intl";
import { useLeadFilesUIContext } from "../LeadFilesUIContext";

export function LeadFileEditDialogHeader({ leadFileForEdit, showEditFileDialog, actionsLoading }) {
  const { headerLabel } = useLeadFilesUIContext();

  const [title, setTitle] = useState("");
  const intl = useIntl();
  useEffect(() => {
    setTitle(
      leadFileForEdit?.id
        ? `${intl.formatMessage({ id: "COMMON.ACTION.EDIT" })}  ${
            leadFileForEdit?.friendlyName ?? ""
          }`
        : intl.formatMessage({ id: "FILE.ACTIONS.UPLOAD.NEW" })
    );
  }, [leadFileForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {!!headerLabel ? <FormattedMessage id={headerLabel} /> : title}
        </Modal.Title>
      </Modal.Header>
    </>
  );
}
